import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[dialogIcon]',
  standalone: true
})
export class DialogIconDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
